import React, { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Api from '../../utils/Api'; // Import your API utility
import './style.css';

const Edit = () => {
  const location = useLocation();
  const token = new URLSearchParams(location.search).get('token');
  console.log('Token in Frontend', token);
  const [successMessage, setSuccessMessage] = useState(false);
  const [dataFetched, setDataFetched] = useState(false);

  // State for form data
  const [formData, setFormData] = useState({
    full_name: '',
    dob: '',
    highest_education: '',
    institution_of_highest_education: '',
    city_of_highest_education: '',
    work_address: '',
    email_address: '',
    work_city: '',
    work_telephone: '',
    residence_address: '',
    residence_city: '',
    residence_telephone: '',
    celluler_phone1: '',
    celluler_phone2: '',
    whatsapp_number: '',
    website: '',
    twitter_handler: '',
    facebook: '',
    linkedin: '',
    instagram: '',
    logged_in_id: '',
    // Add other fields as needed
  });

  // UseEffect hook to fetch data from API
  // UseEffect hook to fetch data from API
  useEffect(() => {
    const fetchData = async () => {
      try {
        // Make API call with the token
        const response = await fetch(`${process.env.REACT_APP_URL_LINK}/edit?token=${token}`);

        const responseData = await response.json();
        console.log('Response:', responseData);

        if (responseData.contactDetail) {
          // Data fetched successfully
          setFormData(responseData.contactDetail);
          setDataFetched(true);
        } else {
          // Data couldn't be fetched, display error message
          console.error('Unable to fetch data:', responseData.message);
          // Handle the error, for example, show a message to the user
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        // Handle the error, for example, show a message to the user
      }
    };

    // Call fetchData function if token exists
    if (token) {
      fetchData();
    }
  }, [token]);
  console.log('Success Message =>', successMessage);

  // Function to handle form submission
  const handleSubmit = async (event) => {
    event.preventDefault();
    try {
      const contactId = formData.id;

      // Make API call to update user data
      const response = await Api.put(`/contact/link/${contactId}`, formData);
      console.log('Response:', response.data);
      setSuccessMessage(true);

      // Handle success or display message to user
    } catch (error) {
      console.error('Error updating data:', error);
      // Handle error or display error message to user
    }
  };

  // Function to handle form field changes
  const handleInputChange = (event) => {
    const { name, value } = event.target;
    setFormData({ ...formData, [name]: value });
  };

  return (
    <div>
      {successMessage ? (
        <h1 style={{ textAlign: 'center' }}>Contact Updated</h1>
      ) : (
        <div>
          {dataFetched ? (
            <form onSubmit={handleSubmit} className="form-container" style={{ marginBottom: '150px' }}>
              <h1 style={{ textAlign: 'center' }}>Edit Contact</h1>
              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="full_name">Full Name</label>

                  <input
                    type="text"
                    name="full_name"
                    value={formData.full_name}
                    onChange={handleInputChange}
                    placeholder="Full Name"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="dob">Date of Birth</label>

                  <input
                    type="text"
                    name="dob"
                    value={formData.dob}
                    onChange={handleInputChange}
                    placeholder="Date of Birth"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="highest_education">Highest Education</label>
                  <input
                    type="text"
                    name="highest_education"
                    value={formData.highest_education}
                    onChange={handleInputChange}
                    placeholder="Highest Education"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="institution_of_highest_education">Institution of Highest Education</label>

                  <input
                    type="text"
                    name="institution_of_highest_education"
                    value={formData.institution_of_highest_education}
                    onChange={handleInputChange}
                    placeholder="Institution of Highest Education"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="city_of_highest_education">City of Highest Education</label>

                  <input
                    type="text"
                    name="city_of_highest_education"
                    value={formData.city_of_highest_education}
                    onChange={handleInputChange}
                    placeholder="City of Highest Education"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="work_address">Work Address</label>

                  <input
                    type="text"
                    name="work_address"
                    value={formData.work_address}
                    onChange={handleInputChange}
                    placeholder="Work Address"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="email_address">Email Address</label>

                  <input
                    type="text"
                    name="email_address"
                    value={formData.email_address}
                    onChange={handleInputChange}
                    placeholder="Email Address"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="work_city">Work City</label>

                  <input
                    type="text"
                    name="work_city"
                    value={formData.work_city}
                    onChange={handleInputChange}
                    placeholder="Work City"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="work_telephone">Work Telephone</label>

                  <input
                    type="text"
                    name="work_telephone"
                    value={formData.work_telephone}
                    onChange={handleInputChange}
                    placeholder="Work Telephone"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="residence_address">Residence Address</label>

                  <input
                    type="text"
                    name="residence_address"
                    value={formData.residence_address}
                    onChange={handleInputChange}
                    placeholder="Residence Address"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="residence_city">Residence City</label>

                  <input
                    type="text"
                    name="residence_city"
                    value={formData.residence_city}
                    onChange={handleInputChange}
                    placeholder="Residence City"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="residence_telephone">Residence Telephone</label>

                  <input
                    type="text"
                    name="residence_telephone"
                    value={formData.residence_telephone}
                    onChange={handleInputChange}
                    placeholder="Residence Telephone"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="celluler_phone1">Cellular Phone 1</label>

                  <input
                    type="text"
                    name="celluler_phone1"
                    value={formData.celluler_phone1}
                    onChange={handleInputChange}
                    placeholder="Cellular Phone 1"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="celluler_phone2">Cellular Phone 2</label>

                  <input
                    type="text"
                    name="celluler_phone2"
                    value={formData.celluler_phone2}
                    onChange={handleInputChange}
                    placeholder="Cellular Phone 2"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="whatsapp_number">Whatsapp Number</label>

                  <input
                    type="text"
                    name="whatsapp_number"
                    value={formData.whatsapp_number}
                    onChange={handleInputChange}
                    placeholder="Whatsapp Number"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="Website">Website</label>

                  <input
                    type="text"
                    name="website"
                    value={formData.website}
                    onChange={handleInputChange}
                    placeholder="Website"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="twitter_handler">Twitter Handle</label>

                  <input
                    type="text"
                    name="twitter_handler"
                    value={formData.twitter_handler}
                    onChange={handleInputChange}
                    placeholder="Twitter Handle"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="facebook">Facebook</label>

                  <input
                    type="text"
                    name="facebook"
                    value={formData.facebook}
                    onChange={handleInputChange}
                    placeholder="Facebook"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="Linkedin">Linkedin</label>

                  <input
                    type="text"
                    name="linkedin"
                    value={formData.linkedin}
                    onChange={handleInputChange}
                    placeholder="Linkedin"
                  />
                </div>
                <div className="form-group">
                  <label htmlFor="Instagram">Instagram</label>
                  <input
                    type="text"
                    name="instagram"
                    value={formData.instagram}
                    onChange={handleInputChange}
                    placeholder="Instagram"
                  />
                </div>
                <div className="button-container">
                  <button type="submit">Submit</button>
                </div>
              </div>
            </form>
          ) : (
            <h1 style={{ textAlign: 'center' }}>You already updated Contact</h1>
          )}
        </div>
      )}
    </div>
  );
};

export default Edit;
